module.exports = __webpack_public_path__ + "img/zahid_mouth.293184bc.jpg";